export class Product {
  constructor (object) {
    this.id = object.id
    this.sku = object.sku
    this.skuSimple = this.getSimplesSku(object)
    this.image = object.image
    this.paidPrice = this.formatPrice(object)
    this.productType = object.productType
    this.quantity = object.quantity
    this.deliveryType = object.deliveryType
    this.pickupInfo = object.pickupInfo
    this.shippingMethod = object.shippingMethod
    this.title = object.title
    this.supplier = object.supplierName
    this.store = object.store
    this.invoice = this.formatInvoice(object)
    this.assembly = object.assembly
    this.manual = this.getManual(object)
    this.customer = this.getCostumerPersonalInfo(object.customers)
    this.invoiceData = object.invoiceData // TODO: Rever este nome de propriedade invoiceData
    this.timelineMos = object.timelineMos // TODO: Rever se será este o nome da propriedade
    this.lastStatus = object.lastStatus // TODO: Rever se será este o nome da propriedade
    this.shippingDeliveryDays = object.shippingDeliveryDays
    this.shippingDeliveryDate = object.shippingDeliveryDate
    this.trackingLink = object.trackingLink
    this.XDWarnings = object.XDWarnings
  }

  formatPrice (object) {
    if (object.paidPrice == null) {
      return null
    }
    return object.paidPrice.toString().replace('.', ',')
  }

  formatInvoice (object) {
    if (object.invoice == null) {
      return {
        xml: null,
        pdf: null
      }
    }

    return object.invoice
  }

  getManual (object) {
    if (object.manual) {
      return object.manual
    }
    return null
  }

  getSimplesSku (object) {
    const sku = object.sku.split('-')
    return sku ? sku[1] : null
  }

  getCostumerPersonalInfo (object) {
    return {
      name: object[0].personal_info.name,
      document: object[0].personal_info.document
    }
  }
}
